import { Input } from 'alurkerja-ui';
import { Search, Settings2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { MainTableColumn } from './MainTable';
import { Menu, MenuButton } from '@headlessui/react';
import ColumnFilterContent from './ColumnFilterContent';
import TableExportButton from './TableExportButton';

export interface TableHeaderProps {
  title: string;
  hideView?: boolean;
  visibleColumns?: Set<string>;
  setVisibleColumns?: (columns: Set<string>) => void;
  variableCols?: MainTableColumn[];
  handleExport?: () => void;
  extraAction?: React.ReactNode;
  isLoadingMutate?: boolean;
  handleSearch?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function TableHeader({
  title,
  hideView,
  visibleColumns,
  setVisibleColumns,
  variableCols = [],
  handleExport,
  extraAction,
  isLoadingMutate = false,
}: Readonly<TableHeaderProps>) {
  const [filteredVariableCols, setFilteredVariableCols] = useState<MainTableColumn[]>(variableCols);

  useEffect(() => {
    if (variableCols.length > 0) {
      setFilteredVariableCols(variableCols);
    }
  }, [variableCols]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value.toLowerCase();
    const filtered = variableCols.filter(
      col => col.label.toLowerCase().includes(searchValue) || col.name.toLowerCase().includes(searchValue),
    );
    setFilteredVariableCols(filtered);
  };

  const hasVariableColumns = variableCols.length > 0;
  const showColumnControls = hasVariableColumns && visibleColumns && setVisibleColumns;

  return (
    <div className={`pt-5 px-5 flex items-center justify-between`}>
      <div className="flex items-center">
        <h1 className="font-semibold text-lg">{title ?? 'Title'}</h1>
      </div>
      <div className="flex justify-end items-center">
        <div className="flex items-center space-x-2">
          <div className="w-72">
            <Input placeholder="Search" name="search" size="sm" rounded="lg" prefix={<Search size={16} />} />
          </div>

          {showColumnControls && !hideView && (
            <Menu>
              <MenuButton>
                <button className="flex flex-row rounded-lg items-center align-middle border py-2 px-[15px] text-black cursor-pointer hover:bg-slate-100 text-sm disabled:opacity-50">
                  <Settings2 size={14} className="mr-1" />
                  View
                </button>
              </MenuButton>

              <ColumnFilterContent
                visibleColumns={visibleColumns}
                setVisibleColumns={setVisibleColumns}
                variableCols={filteredVariableCols}
                handleSearch={handleSearch}
              />
            </Menu>
          )}
          
          {
            extraAction && <div className="ml-2">{extraAction}</div>
          }

          {handleExport && (
            <TableExportButton handleExport={handleExport} isLoadingMutate={isLoadingMutate} />
          )}
        </div>
      </div>
    </div>
  );
}
